<template>
    <td-dialog :title="$t(title)" :before-close="dlalogClose" :visible.sync="isExportVisible" @cancel="dlalogClose" :close-on-click-modal="false" :close-on-press-escape="false" width="35%">
        <el-form :inline="true" ref="fromDeviceExport" v-loading="loading" element-loading-background="rgba(255, 255, 255, 0.5)">
            <el-form-item>
                <td-upload
                    :action="action"
                    :autoUpload="false"
                    ref="uploadDeviceExport"
                    message="pgMessage.ZIP_FILE"
                    :multiple="false"
                    :limit="10"
                    :showFileList="true"
                    accept="zip"
                    :on-success="handResponse"
                    :on-error="handResponse"
                    :http-request="uploadDeviceZip"
                ></td-upload>
            </el-form-item>
        </el-form>
    </td-dialog>
</template>
<script>
import resourceApi from '../assets/api.js';
export default {
    props: {
        title: {
            type: [String, Number]
        },
        // 页面是否显示
        isExportVisible: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        // 设备类型
        iDeviceTypes: {
            type: Array,
            default: function() {
                return [];
            }
        },
        fileParam: {
            type: Object
        },
        // 组织id
        orgId: {
            type: String
        }
    },
    computed: {},
    data() {
        return {
            action: '',
            loading: false
        };
    },
    methods: {
        uploadDeviceZip(content) {
            this.loading = true;
            let file = new FormData();
            file.append('file', content.file);
            file.append('iDeviceType', this.iDeviceTypes[0]);
            file.append('orgId', this.orgId);
            resourceApi.uploadDeviceZip(file, response => {
                this.loading = false;
                if (response.status !== window.pgCommon.login.RESPONSE_STATUS) {
                    this.$log.error('/device/uploadDeviceZip', response);
                    this.$message({
                        showClose: true,
                        message: this.$t('error.ERROR_RESPONSE'),
                        type: 'error'
                    });
                    return;
                }
                if (response.data.statusCode !== window.pgCommon.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({
                        showClose: true,
                        message: response.data.statusMessage,
                        type: 'error'
                    });
                    this.$log.error('/device/uploadDeviceZip', response.data.statusMessage);
                    return;
                }
                if (response.data.content) {
                    this.$message({ showClose: true, message: response.data.content, type: 'error' });
                    return;
                }
                this.$message({
                    showClose: true,
                    message: response.data.statusMessage,
                    type: 'success'
                });
                this.dlalogClose();
                this.$emit('submit');
            });
        },
        // 导入
        handResponse(response, file, fileList) {
            this.loading = false;
            if (response.statusCode !== window.pgCommon.requestCode.SUCCESS_INFO_CODE) {
                this.$message({ showClose: true, message: response.statusMessage, type: 'error' });
                this.$log.error('/device/uploadRouter  ', response.statusMessage);
                return;
            }
            if (response.content) {
                this.$message({ showClose: true, message: response.content, type: 'error' });
                return;
            }
            this.$message({ showClose: true, message: response.statusMessage, type: 'success' });
        },

        dlalogClose() {
            this.$log.info('dlalogClose');
            this.$emit('dlalogClose');
        }
    }
};
</script>
<style>
.uploadStyle {
    text-align: center;
}
</style>
